import { Link } from "react-router";
import { ListaaLogo } from "./ListaaLogo";
import { Instagram, Facebook, Music } from "lucide-react";
import Navigation from "./Navigation";
import { useThemeContext } from "./ThemeContext";
import { CurrencyPicker } from "./CurrencyPicker";
import { ADD_VENUE_URL, useAddVenueGate } from "./AddVenueMemberDialog";

export function Header() {
  return (
    <>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:rounded-md focus:bg-white focus:px-4 focus:py-2 focus:text-black focus:shadow-lg"
      >
        Skip to content
      </a>
      <header className="fixed top-0 left-0 right-0 z-50">
        <Navigation />
      </header>
      {/* Skip-link target: sits right after the fixed nav so keyboard/screen-reader
          users land at the start of page content instead of tabbing through nav links. */}
      <div id="main-content" tabIndex={-1} />
    </>
  );
}

export function Footer() {
  const { isLight, isGlassy } = useThemeContext();
  const addVenueGate = useAddVenueGate();
  return (
    <footer className={`relative ${isGlassy ? "bg-[#0b0b1a]/80 backdrop-blur-xl border-t border-white/[0.08]" : isLight ? "bg-white border-t border-gray-200/60" : "bg-[#0a0a0f] border-t border-white/[0.04]"}`}>
      {/* Venue-style color wash gradient — full width */}
      <div className={`absolute inset-x-0 top-0 h-[260px] ${isGlassy ? "bg-gradient-to-b from-purple-500/15 via-sky-500/8 to-transparent" : isLight ? "bg-gradient-to-b from-rose-100/60 via-purple-100/30 to-transparent" : "bg-gradient-to-b from-[#8b1f47]/40 via-[#4a1f5c]/20 to-transparent"} pointer-events-none`} />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-8 pt-16 pb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-14">
          {/* Brand section */}
          <div>
            <div className="flex flex-col mb-4">
              <ListaaLogo isLight={isLight} className="h-10 self-start" />
              <span className={`text-[10px] ${isGlassy ? "text-gray-500" : "text-gray-400"} tracking-wide mt-0.5`}>Marketplace & Community</span>
            </div>
            <p className="text-gray-400 text-[13px] leading-relaxed mb-7">
              {/* Discover and book the best venues in New York. From nightclubs to fine dining, we've got you covered. */}
              With Listaa, you don't just book venues, you socialize online & offline, make new friends, and make every experience unforgettable.
            </p>
            <div className="flex items-center gap-3">
              <a href="https://instagram.com/listaanyc" target="_blank" rel="noopener noreferrer" aria-label="Listaa on Instagram" className={`w-8 h-8 rounded-full ${isGlassy ? "bg-white/[0.08] border-white/[0.12] text-gray-400 hover:text-white hover:bg-white/[0.14] hover:border-white/[0.2] backdrop-blur-md" : isLight ? "bg-gray-100 border-gray-200/60 text-gray-400 hover:text-gray-900 hover:bg-gray-200/80 hover:border-gray-300/60" : "bg-white/[0.06] border-white/[0.08] text-gray-400 hover:text-white hover:bg-white/[0.1] hover:border-white/[0.15]"} border flex items-center justify-center transition-all`}>
                <Instagram size={14} />
              </a>
              {/* <a href="#" aria-label="Listaa on X (Twitter)" className={`w-8 h-8 rounded-full ${isGlassy ? "bg-white/[0.08] border-white/[0.12] text-gray-400 hover:text-white hover:bg-white/[0.14] hover:border-white/[0.2] backdrop-blur-md" : isLight ? "bg-gray-100 border-gray-200/60 text-gray-400 hover:text-gray-900 hover:bg-gray-200/80 hover:border-gray-300/60" : "bg-white/[0.06] border-white/[0.08] text-gray-400 hover:text-white hover:bg-white/[0.1] hover:border-white/[0.15]"} border flex items-center justify-center transition-all`}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835zm-1.161 17.52h1.833L7.084 4.126H5.117z" fill="currentColor"/>
                </svg>
              </a> */}
              <a href="https://www.facebook.com/profile.php?id=61595296167539" target="_blank" rel="noopener noreferrer" aria-label="Listaa on Facebook" className={`w-8 h-8 rounded-full ${isGlassy ? "bg-white/[0.08] border-white/[0.12] text-gray-400 hover:text-white hover:bg-white/[0.14] hover:border-white/[0.2] backdrop-blur-md" : isLight ? "bg-gray-100 border-gray-200/60 text-gray-400 hover:text-gray-900 hover:bg-gray-200/80 hover:border-gray-300/60" : "bg-white/[0.06] border-white/[0.08] text-gray-400 hover:text-white hover:bg-white/[0.1] hover:border-white/[0.15]"} border flex items-center justify-center transition-all`}>
                <Facebook size={14} />
              </a>
              {/* <a href="#" aria-label="Listaa on TikTok" className={`w-8 h-8 rounded-full ${isGlassy ? "bg-white/[0.08] border-white/[0.12] text-gray-400 hover:text-white hover:bg-white/[0.14] hover:border-white/[0.2] backdrop-blur-md" : isLight ? "bg-gray-100 border-gray-200/60 text-gray-400 hover:text-gray-900 hover:bg-gray-200/80 hover:border-gray-300/60" : "bg-white/[0.06] border-white/[0.08] text-gray-400 hover:text-white hover:bg-white/[0.1] hover:border-white/[0.15]"} border flex items-center justify-center transition-all`}>
                <Music size={14} />
              </a> */}
            </div>
            <div className="flex flex-wrap gap-3 mt-6">
              <a href="https://play.google.com/store/apps/details?id=com.venuelista.app" target="_blank" rel="noopener noreferrer" aria-label="Get Listaa on Google Play" className={`flex items-center gap-3 pl-4 pr-5 py-2.5 rounded-xl border transition-all ${isGlassy ? "bg-white/[0.08] border-white/[0.12] text-white hover:bg-white/[0.14] backdrop-blur-md" : isLight ? "bg-gray-100 border-gray-200/60 text-gray-900 hover:bg-gray-200/80" : "bg-white/[0.04] border-white/[0.1] text-white hover:bg-white/[0.08] hover:border-white/[0.18]"}`}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M3.6 1.8c-.3.3-.5.8-.5 1.4v17.6c0 .6.2 1.1.5 1.4l.1.1 9.9-9.9v-.2L3.7 1.7l-.1.1zm13.3 13.9-3.3-3.3v-.2l3.3-3.3.1.1 3.9 2.2c1.1.6 1.1 1.7 0 2.3l-3.9 2.2h-.1zm-.1.1L13.4 12 3.6 21.8c.4.4 1 .4 1.7.1l11.5-6.1M16.8 8.2 5.3 1.7c-.7-.4-1.3-.3-1.7.1l9.8 9.8 3.4-3.4z"/>
                </svg>
                <span className="flex flex-col leading-tight">
                  <span className={`text-[11px] ${isLight ? "text-gray-500" : "text-gray-400"}`}>Listaa for Android</span>
                  <span className="text-base font-semibold">Google Play</span>
                </span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <div className="flex items-center gap-2.5 mb-5">
              <div className={`w-[3px] h-4 rounded-full ${isGlassy ? "bg-purple-400" : "bg-[#ff3366]"}`} />
              <h3 className={`${isLight ? "text-gray-900" : "text-white"} font-semibold text-sm`}>Quick Links</h3>
            </div>
            <ul className="space-y-3">
              <li>
                <Link to="/venues" className={`${isLight ? "text-gray-500 hover:text-gray-900" : "text-gray-400 hover:text-white"} transition-colors text-[13px]`}>
                  Browse Venues
                </Link>
              </li>
              <li>
                <Link to="/services" className={`${isLight ? "text-gray-500 hover:text-gray-900" : "text-gray-400 hover:text-white"} transition-colors text-[13px]`}>
                  Talents
                </Link>
              </li>
              <li>
                <Link to="/venues" className={`${isLight ? "text-gray-500 hover:text-gray-900" : "text-gray-400 hover:text-white"} transition-colors text-[13px]`}>
                  Nightclubs
                </Link>
              </li>
              <li>
                <Link to="/venues" className={`${isLight ? "text-gray-500 hover:text-gray-900" : "text-gray-400 hover:text-white"} transition-colors text-[13px]`}>
                  Restaurants
                </Link>
              </li>
              <li>
                <Link to="/venues" className={`${isLight ? "text-gray-500 hover:text-gray-900" : "text-gray-400 hover:text-white"} transition-colors text-[13px]`}>
                  Lounges & Bars
                </Link>
              </li>
            </ul>
          </div>

          {/* For Venues */}
          <div>
            <div className="flex items-center gap-2.5 mb-5">
              <div className={`w-[3px] h-4 rounded-full ${isGlassy ? "bg-purple-400" : "bg-[#ff3366]"}`} />
              <h3 className={`${isLight ? "text-gray-900" : "text-white"} font-semibold text-sm`}>For Venues</h3>
            </div>
            <ul className="space-y-3">
              {!addVenueGate.hidden && (
                <li>
                  <a href={ADD_VENUE_URL} className={`${isLight ? "text-gray-500 hover:text-gray-900" : "text-gray-400 hover:text-white"} transition-colors text-[13px]`}>
                    List Your Venue
                  </a>
                </li>
              )}
              <li>
                <a href="https://venuelista.com/pricing" className={`${isLight ? "text-gray-500 hover:text-gray-900" : "text-gray-400 hover:text-white"} transition-colors text-[13px]`}>
                  Pricing
                </a>
              </li>
              {!addVenueGate.hidden && (
                <li>
                  <a href={`${ADD_VENUE_URL}#benefits`} className={`${isLight ? "text-gray-500 hover:text-gray-900" : "text-gray-400 hover:text-white"} transition-colors text-[13px]`}>
                    Partner Benefits
                  </a>
                </li>
              )}
              <li>
                <a href="https://www.vnumngr.com/testimonials" target="_blank" rel="noopener noreferrer" className={`${isLight ? "text-gray-500 hover:text-gray-900" : "text-gray-400 hover:text-white"} transition-colors text-[13px]`}>
                  Success Stories
                </a>
              </li>
            </ul>
          </div>

          {/* Partners */}
          <div>
            <div className="flex items-center gap-2.5 mb-5">
              <div className={`w-[3px] h-4 rounded-full ${isGlassy ? "bg-purple-400" : "bg-[#ff3366]"}`} />
              <h3 className={`${isLight ? "text-gray-900" : "text-white"} font-semibold text-sm`}>Partners</h3>
            </div>
            <ul className="space-y-3">
              <li>
                <a href="https://venuelista.com" target="_blank" rel="noopener noreferrer" className={`${isLight ? "text-gray-500 hover:text-gray-900" : "text-gray-400 hover:text-white"} transition-colors text-[13px]`}>
                  VenueLista
                </a>
              </li>
              <li>
                <a href="https://vnumngr.com" target="_blank" rel="noopener noreferrer" className={`${isLight ? "text-gray-500 hover:text-gray-900" : "text-gray-400 hover:text-white"} transition-colors text-[13px]`}>
                  Vnu Mngr
                </a>
              </li>
              <li>
                <a href="https://promomngr.com" target="_blank" rel="noopener noreferrer" className={`${isLight ? "text-gray-500 hover:text-gray-900" : "text-gray-400 hover:text-white"} transition-colors text-[13px]`}>
                  Promo Mngr
                </a>
              </li>
              <li>
                <a href="https://crmzz.com" target="_blank" rel="noopener noreferrer" className={`${isLight ? "text-gray-500 hover:text-gray-900" : "text-gray-400 hover:text-white"} transition-colors text-[13px]`}>
                  CRMzz
                </a>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <div className="flex items-center gap-2.5 mb-5">
              <div className={`w-[3px] h-4 rounded-full ${isGlassy ? "bg-purple-400" : "bg-[#ff3366]"}`} />
              <h3 className={`${isLight ? "text-gray-900" : "text-white"} font-semibold text-sm`}>Support</h3>
            </div>
            <ul className="space-y-3">
              <li>
                <a href="https://venuelista.com/pricing#faq" className={`${isLight ? "text-gray-500 hover:text-gray-900" : "text-gray-400 hover:text-white"} transition-colors text-[13px]`}>
                  FAQ
                </a>
              </li>
              <li>
                <Link to="/contact" className={`${isLight ? "text-gray-500 hover:text-gray-900" : "text-gray-400 hover:text-white"} transition-colors text-[13px]`}>
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/privacy" className={`${isLight ? "text-gray-500 hover:text-gray-900" : "text-gray-400 hover:text-white"} transition-colors text-[13px]`}>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className={`${isLight ? "text-gray-500 hover:text-gray-900" : "text-gray-400 hover:text-white"} transition-colors text-[13px]`}>
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/community-guidelines" className={`${isLight ? "text-gray-500 hover:text-gray-900" : "text-gray-400 hover:text-white"} transition-colors text-[13px]`}>
                  Community Guidelines
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className={`relative mt-14 pt-6 border-t ${isGlassy ? "border-white/[0.08]" : isLight ? "border-gray-200/60" : "border-white/[0.05]"} flex flex-col md:flex-row justify-between items-center gap-4 pb-20 md:pb-0`}>
          <div className={`flex items-center gap-2 text-[13px] text-center ${isGlassy ? "text-gray-500" : "text-gray-400"}`}>
            <div className={`w-2.5 h-2.5 rounded-full ${isGlassy ? "bg-purple-400" : "bg-[#ff3366]"}`} />
            <span>© 2026 Listaa. All rights reserved.</span>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-y-2 gap-x-1 text-[13px] max-w-full">
            <Link to="/privacy" className={`${isLight ? "text-gray-400 hover:text-gray-900" : "text-gray-400 hover:text-white"} transition-colors px-3 py-1`}>Privacy</Link>
            <span className={`hidden sm:inline ${isGlassy ? "text-gray-600" : isLight ? "text-gray-300" : "text-gray-700/50"}`}>|</span>
            <Link to="/terms" className={`${isLight ? "text-gray-400 hover:text-gray-900" : "text-gray-400 hover:text-white"} transition-colors px-3 py-1`}>Terms</Link>
            <span className={`hidden sm:inline ${isGlassy ? "text-gray-600" : isLight ? "text-gray-300" : "text-gray-700/50"}`}>|</span>
            <Link to="/cookies" className={`${isLight ? "text-gray-400 hover:text-gray-900" : "text-gray-400 hover:text-white"} transition-colors px-3 py-1`}>Cookies</Link>
            <span className={`hidden sm:inline ${isGlassy ? "text-gray-600" : isLight ? "text-gray-300" : "text-gray-700/50"}`}>|</span>
            <Link to="/community-guidelines" className={`${isLight ? "text-gray-400 hover:text-gray-900" : "text-gray-400 hover:text-white"} transition-colors px-3 py-1`}>Guidelines</Link>
            <span className={`hidden sm:inline ${isGlassy ? "text-gray-600" : isLight ? "text-gray-300" : "text-gray-700/50"}`}>|</span>
            <CurrencyPicker
              isLight={isLight}
              triggerClassName={`flex items-center gap-1.5 transition-colors px-3 py-1 ${isLight ? "text-gray-400 hover:text-gray-900" : "text-gray-400 hover:text-white"}`}
            />
          </div>
        </div>
      </div>
    </footer>
  );
}
